import script from "./AddPodcastAdminShow.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPodcastAdminShow.vue?vue&type=script&setup=true&lang=js"

import "./AddPodcastAdminShow.vue?vue&type=style&index=0&id=390fa342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390fa342"]])

export default __exports__